



import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
import MapResolver from '../../util/MapResolver';

@Component({
  name: 'LayoutDemoView',
  components: {},
  mixins: [MapResolver],
})
export default class LayoutDemoView extends Vue {
  @Injectable() public container!: Container;
  constructor() {
    super();
  }

  private async display_points() {
    const comp: any = await this.getComponent();
    comp.display_linear();
  }

  private getComponent(
    moduleName: string = 'Demo',
    componentName: string = 'demoComponent',
  ) {
    const p = new Promise((resolve, reject) => {
      (this as any)
        .resolveMap('map')
        .then((data: any) => {
          const temp: any = this;
          const factory = temp.container.resolve('mapShare').comFactory;
          const component = factory.getComponent(moduleName, componentName);
          resolve(component);
        })
        .catch(() => {
          reject('获取地图组件失败');
        });
    });
    return p;
  }
}
